import OrganizationLD from './OrganizationLD'

export default OrganizationLD
